{
    "table_header__location": "Location",
    "table_header__unit": "Unit",
    "table_header__inventory": "Inventory",
    "table_header__reserved": "Reserved",
    "table_header__picked": "Picked",
    "table_header__effective_inventory": "Free stock"
}
